import * as React from 'react'
import type { LinkComponent } from '../types'

export interface HeroButtonProps {
  /** Brand-filled emphasis (maps to `data-primary`). */
  primary: boolean;
  /** In-app link component (e.g. React Router's `Link`). */
  LinkComponent: LinkComponent;
  /** Button label. */
  text: string;
  /** Destination. An absolute `http(s)` URL opens in a new tab; anything else
   *  is treated as an in-app route and rendered through {@link HeroButtonProps.LinkComponent}. */
  href: string;
}

/**
 * The call-to-action button used inside the {@link Hero}. Renders a plain anchor
 * for external links and the injected router link for in-app routes, so
 * client-side navigation is preserved. Styled through the styleguide's
 * `.mlsg-hero-button` primitive.
 */
export const HeroButton: React.FC<HeroButtonProps> = props => {
  if (props.href.startsWith('http')) {
    return (
      <a href={props.href} target='_blank' className='mlsg-hero-button' data-primary={props.primary} rel='noreferrer'>
        {props.text}
      </a>
    )
  }

  const LinkComponent = props.LinkComponent
  return (
    <LinkComponent to={props.href} className='mlsg-hero-button' data-primary={props.primary}>
      {props.text}
    </LinkComponent>
  )
}
